import React from "react";
import { Box, Flex } from "rebass/styled-components";
import styled from "styled-components";
import { useLocation } from "react-router-dom";

/*  Our Typings */
import { TStudioNavContent } from "../../../../@types";

/*  Our LOCAL component imports */
import StudioFacet from "./Components/StudioFacet";

/*  Our GLOBAL component imports */
import { Headline } from "../../../../Components/Text";
import { colors } from "../../../../../theme/colors";
import { useTranslation } from "react-i18next";

const GameHeadline = ({ path }: any) => {
  const { t } = useTranslation("translation", {
    keyPrefix: "studio",
  });

  if (path?.includes("remix")) return null;

  return <StyledHeadline>{t("games")}</StyledHeadline>;
};

export const FacetPanel = ({
  isVisible,
  toggleVisible,
  query,
  onQuery,
  facets,
  facetLoading,
}: any) => {
  const location = useLocation();

  return (
    <>
      <StickyStudioNav open={isVisible}>
        <StudioNavContent px={2} isVisible={isVisible}>
          <Box>
            <StyledGames mt={7} alignItems={"center"}>
              <GameHeadline path={location.pathname} />
            </StyledGames>
          </Box>
          <StyledHeaderSection
            style={{
              cursor: "pointer",
              backgroundColor: colors.nedLight,
              color: colors.chalk,
            }}
          >
            {facets?.map((facet: any) => (
              <StudioFacet
                key={facet.identifier}
                path={location.pathname}
                facet={facet}
                onQuery={onQuery}
                query={query}
                facetLoading={facetLoading}
                style={{
                  cursor: "pointer",
                  backgroundColor: colors.nedLight,
                }}
              />
            ))}
          </StyledHeaderSection>
        </StudioNavContent>
      </StickyStudioNav>
    </>
  );
};

const StyledGames = styled(Flex)``;

const StyledHeaderSection = styled(Headline)`
  font-weight: 600;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

const StickyStudioNav = styled(Flex)<any>`
  flex-direction: column;
  width: 100%;
  max-width: ${(props: any) => (props.open ? "280px" : "97%")};
  background: ${(props: any) => props.theme.colors.nedLight};
  transform: ${({ open }) => (open ? "translateX(0)" : "translateX(-100%)")};
  height: calc(100vh - 60px);
  text-align: left;
  padding: 10px;
  position: sticky;
  top: 60px;
  box-shadow: 3px 0px 10px rgb(12, 19, 24, 0.3);
  left: 0;
  transition: transform 0.2s ease-in-out;
  z-index: ${(props) => (props.open ? 19 : -1000)};

  @media (max-width: ${(props) => props.theme.breaks.medium}) {
      width: 100vw;
      max-width: 97%;
      position: fixed;
    }
  }
`;

const StudioNavContent = styled(Flex)<TStudioNavContent>`
  flex-direction: column;
  opacity: 0;
  visibility: hidden;
  overflow: auto;
  transition: opacity 200ms ease, visibility 200ms ease 0s;
  visibility: ${(props: any) => (props.isVisible ? "visible" : "hidden")};
  ${(props: any) => (props.isVisible ? "opacity: 1" : null)};

  ::-webkit-scrollbar {
    display: none;
  }

   {
    -ms-overflow-style: none;
    scrollbar-width: none;
  }
`;

const StyledHeadline = styled(Headline)`
  font-weight: 600;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 12px;
  text-transform: uppercase;
`;
